import { jsx as _jsx } from "react/jsx-runtime";
import cn from "../../../utils/cn";
import Typography from "../../Typography";
const BannerTitle = ({ className, children, color = "secondary", variant = "text-md-medium" }) => {
    return (_jsx(Typography, { color: color, variant: variant, className: cn(className, "text-gray-12"), children: children }));
};
export default BannerTitle;
